import React from "react";
import BtnTiertary from "../../../../boiteAOutils/BtnTiertary";
import BtnSvg from "../../../../boiteAOutils/BtnSvg";

const DispositionControls = ({
                                 sendToBack,
                                 bringToFront,
                                 moveBackward,
                                 moveForward,
                                 deleteSelectedObject,
                                 copyObject,
                                 pasteObject
                             }) => {
    return (
        <>
            <div className="sidebar-section">Disposition</div>

            <div className="sidebar-disposition">
                <div>Faire bouger en :</div>
                <div style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    gap: "10px"
                }}>
                    <div style={{cursor: "pointer"}} onClick={sendToBack}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M10 8H6C5.71875 8 5.5 8.25 5.5 8.5V12.5C5.5 12.7812 5.71875 13 6 13H10C10.25 13 10.5 12.7812 10.5 12.5V8.5C10.5 8.25 10.25 8 10 8ZM6 6.5H10C11.0938 6.5 12 7.40625 12 8.5V12.5C12 13.625 11.0938 14.5 10 14.5H6C4.875 14.5 4 13.625 4 12.5V8.5C4 7.40625 4.875 6.5 6 6.5ZM22 16H18C17.7188 16 17.5 16.25 17.5 16.5V20.5C17.5 20.7812 17.7188 21 18 21H22C22.25 21 22.5 20.7812 22.5 20.5V16.5C22.5 16.25 22.25 16 22 16ZM18 14.5H22C23.0938 14.5 24 15.4062 24 16.5V20.5C24 21.625 23.0938 22.5 22 22.5H18C16.875 22.5 16 21.625 16 20.5V16.5C16 15.4062 16.875 14.5 18 14.5ZM9 15.5H10C11.6562 15.5 13 14.1562 13 12.5V9.5H17C18.0938 9.5 19 10.4062 19 11.5V13.5H18C16.3438 13.5 15 14.8438 15 16.5V19.5H11C9.875 19.5 9 18.625 9 17.5V15.5Z"
                                fill="#002335"
                            />
                        </svg>
                    </div>
                    <div style={{cursor: "pointer"}} onClick={bringToFront}>
                        <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M6 8C5.71875 8 5.5 8.25 5.5 8.5V12.5C5.5 12.7812 5.71875 13 6 13H8V14.5H6C4.875 14.5 4 13.625 4 12.5V8.5C4 7.40625 4.875 6.5 6 6.5H10C11.0938 6.5 12 7.40625 12 8.5H10.5C10.5 8.25 10.25 8 10 8H6ZM18 22.5C16.875 22.5 16 21.625 16 20.5H17.5C17.5 20.7812 17.7188 21 18 21H22C22.25 21 22.5 20.7812 22.5 20.5V16.5C22.5 16.25 22.25 16 22 16H20V14.5H22C23.0938 14.5 24 15.4062 24 16.5V20.5C24 21.625 23.0938 22.5 22 22.5H18ZM11 9.5H17C18.0938 9.5 19 10.4062 19 11.5V17.5C19 18.625 18.0938 19.5 17 19.5H11C9.875 19.5 9 18.625 9 17.5V11.5C9 10.4062 9.875 9.5 11 9.5Z"
                                fill="#002335"
                            />
                        </svg>
                    </div>
                </div>
            </div>

            <div style={{
                display: 'flex',
                gap: '10px',
                padding: "4px 0px",
                alignItems: "center"
            }}>
                <div style={{display: 'flex', alignItems: "center"}}>
                    <div style={{width: "28px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M2 0.5H9C10.0938 0.5 11 1.40625 11 2.5V4.5H7C5.34375 4.5 4 5.84375 4 7.5V11.5H2C0.875 11.5 0 10.625 0 9.5V2.5C0 1.40625 0.875 0.5 2 0.5ZM7 7C6.71875 7 6.5 7.25 6.5 7.5V14.5C6.5 14.7812 6.71875 15 7 15H14C14.25 15 14.5 14.7812 14.5 14.5V7.5C14.5 7.25 14.25 7 14 7H7ZM5 7.5C5 6.40625 5.875 5.5 7 5.5H14C15.0938 5.5 16 6.40625 16 7.5V14.5C16 15.625 15.0938 16.5 14 16.5H7C5.875 16.5 5 15.625 5 14.5V7.5Z"
                                fill="#002335"
                            />
                        </svg>
                    </div>
                    <BtnTiertary onClick={moveBackward} style={{
                        "padding": "4px 8px",
                        "background": "#FFF",
                        "border-radius": "2px"
                    }}>Reculer</BtnTiertary>
                </div>

                <div style={{display: 'flex', alignItems: "center"}}>
                    <div style={{width: "28px", display: "flex", alignItems: "center", justifyContent: "center"}}>
                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M7 15H14C14.25 15 14.5 14.7812 14.5 14.5V7.5C14.5 7.25 14.25 7 14 7H12V5.5H14C15.0938 5.5 16 6.40625 16 7.5V14.5C16 15.625 15.0938 16.5 14 16.5H7C5.875 16.5 5 15.625 5 14.5V12.5H6.5V14.5C6.5 14.7812 6.71875 15 7 15ZM9 11.5H2C0.875 11.5 0 10.625 0 9.5V2.5C0 1.40625 0.875 0.5 2 0.5H9C10.0938 0.5 11 1.40625 11 2.5V9.5C11 10.625 10.0938 11.5 9 11.5Z"
                                fill="#002335"
                            />
                        </svg>
                    </div>
                    <BtnTiertary onClick={moveForward} style={{
                        "padding": "4px 8px",
                        "background": "#FFF",
                        "border-radius": "2px"
                    }}>Avancer</BtnTiertary>
                </div>
            </div>

            <div style={{
                display: 'flex',
                gap: '10px',
                padding: "4px 0px",
                alignItems: "center"
            }}>
                <div style={{display: 'flex', alignItems: "center"}}>
                    <BtnTiertary onClick={copyObject} style={{
                        "padding": "4px 8px",
                        "background": "#FFF",
                        "border-radius": "2px"
                    }}>Copier</BtnTiertary>
                </div>
                <div style={{display: 'flex', alignItems: "center"}}>
                    <BtnTiertary onClick={pasteObject} style={{
                        "padding": "4px 8px",
                        "background": "#FFF",
                        "border-radius": "2px"
                    }}>Coller</BtnTiertary>
                </div>
            </div>

            <div className={"sidebar-bouton-supprimer"} style={{}}>Supprimer
                <div><BtnSvg
                    svg={"corbeille"} onClick={deleteSelectedObject}/></div>
            </div>
        </>
    );
};

export default DispositionControls;
